// Pure usage-gate decision logic (#58). No Vue, no side effects — kept
// separate from useUsageGate.ts so the fail-open guards (including the
// GATE_ENABLED kill-switch) are unit-testable in isolation. Mirrors the
// performance-calculator's usageGateLogic.js.
//
// The WebView app signals (`window.NotamBrieferApp`, `nb_app_installed`)
// were removed at Phase 5: the Flutter client never loads this SPA, so a
// forgeable browser-side "I am the app" switch protected nobody.

export interface GateBypassInput {
  gateEnabled: boolean;
  hostname: string;
}

export type GateBypassReason = 'disabled' | 'localhost';

/**
 * Returns the reason the gate must NOT fire (fail-open), or null if the gate
 * is allowed to proceed to the server count. Kill-switch first, then dev.
 *
 *   - 'disabled'  — GATE_ENABLED kill-switch is off
 *   - 'localhost' — dev origin (the prod-only WP endpoint isn't reachable)
 */
export function gateBypassReason(input: GateBypassInput): GateBypassReason | null {
  if (!input.gateEnabled) return 'disabled';
  if (input.hostname === 'localhost' || input.hostname === '127.0.0.1') return 'localhost';
  return null;
}
